import { render } from "./UserPageView.vue?vue&type=template&id=77ff9de4&scoped=true&ts=true"
import script from "./UserPageView.vue?vue&type=script&lang=ts"
export * from "./UserPageView.vue?vue&type=script&lang=ts"

import "./UserPageView.vue?vue&type=style&index=0&id=77ff9de4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ff9de4"]])

export default __exports__